import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export const Breadcrumbs = (props) => {
    const {
        configurationData,
        selections,
        setSelections,
        resetDiversityDict,
    } = props
    
    const handleClick = (selections) => {
        resetDiversityDict();
        setSelections(selections)
    }
    return (
        <div className="breadcrumb-row">
            <div
                className="standard-breadcrumb"
                onClick={() => handleClick([])}
            >
                Home
            </div>
            <div className="breadcrumb-chevron">
                <ChevronRightIcon style={{fontSize: '1.3vw'}}/>
            </div>
            {selections?.map((selection, i) => (
                <>
                    <div 
                        className={i !== selections.length - 1 ? "standard-breadcrumb" : "final-breadcrumb"}
                        onClick={() => handleClick(selections.slice(0, i + 1))}
                    >
                        {configurationData.find(configRow => (
                            configRow[5] === selection
                        ))[10]}
                    </div>
                    { i !== selections.length - 1 && (
                        <div className="breadcrumb-chevron">
                            <ChevronRightIcon style={{fontSize: '1.3vw'}}/>
                        </div>
                    )}
                </>
            ))}
        </div>
    )
}